import useGetManagedInstallersDevices
  from '../../../../queries/managedInstallersDetails/useGetManagedInstallersDevices';
import WdacManagedInstallersTable from '../../../wdac-results/tabs/WdacManagedInstallers/WdacManagedInstallersTable';

const ManagedInstallersSection = () => {
  const {
    isLoading,
    data: managedInstallerList,
    lastElementRef,
    isFetching,
    count,
    query,
  } = useGetManagedInstallersDevices();

  return (
    <WdacManagedInstallersTable
      isLoading={isLoading}
      isFetching={isFetching}
      managedInstallerList={managedInstallerList}
      lastElementRef={lastElementRef}
      totalCount={count}
      query={query}
      isDeviceContext={true}
    />
  );
};

export default ManagedInstallersSection;
